var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1548,
    height: 160,
    viewBox: "0 0 1548 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_35920)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_541_35920)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.239,
    cy: 165,
    r: 250,
    fill: "#1782FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter1_f_541_35920)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188.358,
    cy: 165,
    r: 250,
    fill: "#50B7F0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter2_f_541_35920)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1298,
    cy: 165,
    r: 250,
    fill: "#DC45EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter3_f_541_35920)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 928.119,
    cy: 165,
    r: 250,
    fill: "url(#paint0_linear_541_35920)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1394,
    width: 6,
    height: 137,
    fill: "url(#paint1_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    width: 6,
    height: 137,
    fill: "url(#paint2_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1426,
    width: 6,
    height: 137,
    fill: "url(#paint3_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1442,
    width: 6,
    height: 137,
    fill: "url(#paint4_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458,
    width: 6,
    height: 137,
    fill: "url(#paint5_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474,
    width: 6,
    height: 137,
    fill: "url(#paint6_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1490,
    width: 6,
    height: 137,
    fill: "url(#paint7_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    width: 6,
    height: 137,
    fill: "url(#paint8_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1522,
    width: 6,
    height: 137,
    fill: "url(#paint9_linear_541_35920)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1250 160)",
    fill: "url(#paint10_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1266 160)",
    fill: "url(#paint11_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1282 160)",
    fill: "url(#paint12_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1298 160)",
    fill: "url(#paint13_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1314 160)",
    fill: "url(#paint14_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1330 160)",
    fill: "url(#paint15_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1346 160)",
    fill: "url(#paint16_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1362 160)",
    fill: "url(#paint17_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 1378 160)",
    fill: "url(#paint18_linear_541_35920)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 0 160)",
    fill: "url(#paint19_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 16 160)",
    fill: "url(#paint20_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 32 160)",
    fill: "url(#paint21_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 48 160)",
    fill: "url(#paint22_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 64 160)",
    fill: "url(#paint23_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 80 160)",
    fill: "url(#paint24_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 96 160)",
    fill: "url(#paint25_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 112 160)",
    fill: "url(#paint26_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 137,
    transform: "matrix(1 0 0 -1 128 160)",
    fill: "url(#paint27_linear_541_35920)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143,
    width: 6,
    height: 137,
    fill: "url(#paint28_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    width: 6,
    height: 137,
    fill: "url(#paint29_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    width: 6,
    height: 137,
    fill: "url(#paint30_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    width: 6,
    height: 137,
    fill: "url(#paint31_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    width: 6,
    height: 137,
    fill: "url(#paint32_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    width: 6,
    height: 137,
    fill: "url(#paint33_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    width: 6,
    height: 137,
    fill: "url(#paint34_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    width: 6,
    height: 137,
    fill: "url(#paint35_linear_541_35920)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    width: 6,
    height: 137,
    fill: "url(#paint36_linear_541_35920)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_541_35920",
    x: 108.239,
    y: -285,
    width: 900,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_541_35920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_541_35920",
    x: -261.642,
    y: -285,
    width: 900,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_541_35920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_541_35920",
    x: 848,
    y: -285,
    width: 900,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_541_35920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_541_35920",
    x: 478.119,
    y: -285,
    width: 900,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_541_35920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_35920",
    x1: 678.119,
    y1: -43.3333,
    x2: 1241.61,
    y2: 69.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_541_35920",
    x1: 1397,
    y1: 1.59627e-7,
    x2: 1397,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_541_35920",
    x1: 1413,
    y1: 1.59627e-7,
    x2: 1413,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_541_35920",
    x1: 1429,
    y1: 1.59627e-7,
    x2: 1429,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_541_35920",
    x1: 1445,
    y1: 1.59627e-7,
    x2: 1445,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_541_35920",
    x1: 1461,
    y1: 1.59627e-7,
    x2: 1461,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_541_35920",
    x1: 1477,
    y1: 1.59627e-7,
    x2: 1477,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_541_35920",
    x1: 1493,
    y1: 1.59627e-7,
    x2: 1493,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_541_35920",
    x1: 1509,
    y1: 1.59627e-7,
    x2: 1509,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_541_35920",
    x1: 1525,
    y1: 1.59627e-7,
    x2: 1525,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_541_35920",
    x1: 3,
    y1: 1.59627e-7,
    x2: 3,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_541_35920",
    x1: 146,
    y1: 1.59627e-7,
    x2: 146,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_541_35920",
    x1: 162,
    y1: 1.59627e-7,
    x2: 162,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_541_35920",
    x1: 178,
    y1: 1.59627e-7,
    x2: 178,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_541_35920",
    x1: 194,
    y1: 1.59627e-7,
    x2: 194,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_541_35920",
    x1: 210,
    y1: 1.59627e-7,
    x2: 210,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_541_35920",
    x1: 226,
    y1: 1.59627e-7,
    x2: 226,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_541_35920",
    x1: 242,
    y1: 1.59627e-7,
    x2: 242,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_541_35920",
    x1: 258,
    y1: 1.59627e-7,
    x2: 258,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_541_35920",
    x1: 274,
    y1: 1.59627e-7,
    x2: 274,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_35920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1548,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsHeader);
export default __webpack_public_path__ + "static/media/contactUsHeader.bc7911c7c53553c626a05ed731d064b7.svg";
export { ForwardRef as ReactComponent };